import $ from 'jquery';

import Events from './events';


var REGEXPS = {
  EQ: /=+$/,
  PLUS: /[+]/g,
  SLASH: /\//g
};


function normalize(items) {
  return (
    items &&
    items
      .filter(function (item) {
        return (
          'items' in item || item.divider || item.text ||
          (item.attr && item.attr.id)
        );
      })
      .map(function (item) {
        if ('items' in item)
          item.items = normalize(item.items);
        else if (item.divider)
          item = {text: ' ', cssClass: 'chi-menu-divider'};
        if (item.attr && item.attr.id && !item.attr.id.startsWith('b64:'))
          item.attr.id =
            'b64:' + btoa(item.attr.id)
              .replace(REGEXPS.EQ, '')
              .replace(REGEXPS.PLUS, '-')
              .replace(REGEXPS.SLASH, '_');
        return item;
      })
  );
}

function on_activate() {
  console.debug('on-menu-activate', this);
  window.vm.$options.context_menu = this;
  this.element.closest('.k-animation-container').css({'z-index': 99999});
  this.element.focus();
  this.target.data('target').addClass('chi-menu-open');
}

function on_deactivate(event) {
  console.debug('on-menu-deactivate', this, event);
  // have to kick this code out of the event loop or it keeps kendo from
  // cleaning up its animation container, which remains, invisibly, on top
  // of the screens, blocking interaction with whatever it covers
  if ($(event.item).hasClass('k-context-menu'))
    setImmediate(function (self) {
      self.target.data('target').removeClass('chi-menu-open');
      self.wrapper.remove();
      self.destroy();
      if (event.target.nodeName === 'A')
        window.vm.$options.context_menu = null;
      var active = $('#' + window.vm.$options.api.vm.active_element);
      if (active.data('role') === 'grid')
        active = active.data('kendo-grid').table;
      active.focus();
    }, this);
  else
    event.preventDefault();
}

function on_select(event) {
  console.debug('on-menu-select', this, event);
  if ($(event.item).hasClass('chi-menu-divider'))
    event.stopImmediatePropagation();
}

// create a "clone" of the target at the document root with the same
// position and dimensions, and target the menu off of it, so that kendo
// doesn't spend a ton of time finding the z-index.
// we have to do this because when kendo calculates the correct z-index,
// it walks pretty much the whole stupid dom tree looking for z-index
// values, so it takes *forever* if there are a lot of elements.
function create_menu(vm, target, data, attrs) {
  console.debug('create-menu', this, vm, target, data, attrs);
  if (!target)
    return console.warn('no target for context menu');
  attrs = attrs ? ' class="chi-' + attrs + '"' : '';
  var clone = $('<div' + attrs + '></div>')
    .css({
      height: target.outerHeight(),
      overflow: 'visible',
      position: 'absolute',
      width: target.outerWidth()
    })
    .offset(target.offset())
    .appendTo(document.body);
  clone.data('target', target);
  return $('<div></div>').insertAfter(clone).kendoContextMenu({
    activate: on_activate,
    alignToAnchor: true,
    dataSource: data,
    deactivate: on_deactivate,
    orientation: 'vertical',
    select: Events.on_menu_select.bind(vm),
    target: clone
  });
}

export default {
  normalize: normalize,
  on_activate: on_activate,
  on_deactivate: on_deactivate,
  on_select: on_select,
  create_menu: create_menu
};
